import { useEffect } from 'react';
import { useGetState, useMemoizedFn } from 'ahooks';
import { notification } from 'tea-component';
import { createDownloadService } from '@gp/hooks/useDownload';
import { downloadAttachmentOfManagement as downloadAttachmentOfManagementOriginal } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import { downloadFileByBlob, stream2Object } from '@gp/utils/common';
import {
  getAttachmentKey,
  getInitialMeetingsAttachmentDownloadings,
} from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/Meetings/utils';

const downloadAttachmentOfManagement = createDownloadService(downloadAttachmentOfManagementOriginal);

export default function useAttachmentDownload(options: {
  studioId: string;
  meetings?: IStudioManagementMeeting[];
  setExpandedMeetingId: React.Dispatch<React.SetStateAction<string>>;
}) {
  const { studioId, meetings, setExpandedMeetingId } = options || {};

  // 文档下载loading状态集合
  const [attachmentDownloadings, setAttachmentDownloadings, getAttachmentDownloadings] =
    useGetState<IStudioManagementMeetingAttachmentDownloadings>({});

  // 文档下载
  const handleAttachmentDownload = useMemoizedFn<IStudioManagementMeetingAttachmentActionHandler>(
    async (meeting, attachment) => {
      const attachmentKey = getAttachmentKey(meeting, attachment);
      try {
        const oldAttachmentDownloadings = getAttachmentDownloadings();
        const attachmentDownloadingsTemp = {
          ...oldAttachmentDownloadings,
          [attachmentKey]: true,
        };
        setAttachmentDownloadings(attachmentDownloadingsTemp);
        setExpandedMeetingId?.(String(meeting?.id || ''));
        const { stream, fileName } = await downloadAttachmentOfManagement({
          path: attachment?.filePath,
          studioID: studioId,
        });
        downloadFileByBlob(stream, fileName);
        notification.success({
          unique: true,
          description: 'Download successfully',
        });
      } catch (res: any) {
        const resData = await stream2Object(res?.data);
        notification.error({
          unique: true,
          description: 'Download failed',
        });
        console.warn(resData?.msg || '');
      } finally {
        const oldAttachmentDownloadings = getAttachmentDownloadings();
        const attachmentDownloadingsTemp = {
          ...oldAttachmentDownloadings,
          [attachmentKey]: false,
        };
        setAttachmentDownloadings(attachmentDownloadingsTemp);
      }
    },
  );

  useEffect(() => {
    setAttachmentDownloadings(getInitialMeetingsAttachmentDownloadings(meetings));
  }, [meetings]);

  return {
    attachmentDownloadings,
    onAttachmentDownload: handleAttachmentDownload,
  };
}
